import { getVoipService } from "@ntconnect/framework/pbx";

/**
 * ntconnect VoIP (trunk) API — thin wrappers over the framework's VoipService,
 * which proxies through the BFF's /ntconnect/* surface. One VoIP per tenant.
 *
 * provisionVoip(): POST /ntconnect/voip. Idempotent — a repeat call returns
 * 409 ("voip already provisioned"), which callers should treat as success
 * (the trunk exists). Used when a tenant upgrades to a paid plan.
 */
export const provisionVoip = () => getVoipService().provisionVoip();

export const fetchTrunk = () => getVoipService().fetchTrunk();

export const fetchSip = () => getVoipService().fetchSip();
